export default __webpack_public_path__ + "static/media/real_token.ccd31816.svg";